/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskDraft } from './taskDraft';

export interface LevelDraft {
  title: string;
  learningObjectives: string[];
  tasks: TaskDraft[];
}
